<!--
 * @Author: pluto.guo 66291979@qq.com
 * @Date: 2025-03-03 14:14:38
 * @LastEditors: game.pluto.com 66291979@qq.com
 * @LastEditTime: 2025-03-04 17:29:43
 * @FilePath: \lobby\src\components\deposit\SelectPayMethodsComponent.vue
 * @Description: 
 * 
 * Copyright (c) 2025 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <!-- <div>
    <PaymentMethod :updateData="onUpdatePayMethod" from="deposit"> </PaymentMethod>
  </div> -->
  <div class="dw_con_et">
    <ul style="border-top-width: 0px; border-bottom-width: 0px">
      <div class="dw_title">
        {{ from == 'deposit' ? $t('payment.paymentoption') : $t('payment.select') }}
      </div>
      <div class="dw_Pay">
        <div v-for="(list, i) in methodConfig" :key="i" class="dw_row">
          <div
            v-for="(item, j) in list"
            :key="j"
            :class="`${seleceBankCode == i * 3 + j ? 'active_bankCode' : 'un_active_bankCode'}`"
          >
            <img v-if="item" :src="item.icon" alt="" @click="onSelectBankCode(i * 3 + j)" />
            <div v-else class="un_active_bankCode"></div>
          </div>
        </div>
      </div>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useUserStore } from '@/stores/user'
import { closeToast, showLoadingToast } from 'vant'
import { BUS, POPUP } from '@/event/EventCenter'
import { config } from '@/common/config'
import { chunkArray } from '@/utils/helper'

export default {
  name: 'SelectPayMethodsComponent',
  props: {
    from: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      resBaseUrl: config.resBaseUrl,
      telebirr: [],
      cbebirr: [],
      mpesa: [],
      other: [],
      isShowMore: false,
      selectChannel: {
        id: -1
      },
      seleceBankCode: 0,
      methodConfig: []
    }
  },
  computed: {
    ...mapState(useUserStore, ['country', 'userInfo', 'isLogin'])
  },
  mounted() {
    showLoadingToast({
      message: '',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0
    })
    if (this.isLogin) {
      if (this.userInfo.rechargeChannel && this.userInfo.rechargeChannel != '') {
        this.selectChannel == { id: this.userInfo.rechargeChannel }
      }
      if (this.from == 'withdraw') {
        this.withdrawPayMentMethods()
          .then((r) => {
            this.parsePayMentDethods(r.configs)
          })
          .catch(() => {
            setTimeout(() => {
              closeToast()
            }, 500)
          })
      } else {
        this.paymentMethods()
          .then((r) => {
            this.parsePayMentDethods(r.configs)
          })
          .catch(() => {
            setTimeout(() => {
              closeToast()
            }, 500)
          })
      }
    } else {
      setTimeout(() => {
        closeToast()
      }, 500)
      this.$bus.$emit(BUS.SHOW_POPUP, { from: this.from, to: POPUP.LOGIN, show: true })
    }
  },
  methods: {
    ...mapActions(useUserStore, {
      paymentMethods: 'paymentMethods',
      withdrawPayMentMethods: 'withdrawPayMentMethods'
    }),
    parsePayMentDethods(configs) {
      const paymentMethodGroups = {}
      const isDeposit = this.from === 'deposit'
      
      // 通用支付方式分组逻辑
      const groupPaymentMethods = (items) => {
        items.forEach(item => {
          paymentMethodGroups[item.paymentMethod] = 
            (paymentMethodGroups[item.paymentMethod] || []).concat(item)
        })
      }

      // 根据来源过滤并分组支付方式
      if (isDeposit) {
        groupPaymentMethods(configs.filter(item => item.routing === 'direct'))
        this.other = configs.filter(item => item.routing !== 'direct')
      } else {
        groupPaymentMethods(configs)
      }

      // 设置主要支付方式
      this.telebirr = paymentMethodGroups['telebirr'] || []
      this.cbebirr = paymentMethodGroups['cbebirr'] || []
      this.mpesa = paymentMethodGroups['mpesa'] || []

      // 设置默认支付渠道
      const cleanNumber = this.userInfo.phoneNumber
      const isMpesa = /^07\d{8}$/.test(cleanNumber) || /^7\d{8}$/.test(cleanNumber)
      const defaultChannel = isMpesa ? this.cbebirr[0] : this.telebirr[0]
      
      this.selectChannel = this.selectChannel.id === -1 
        ? defaultChannel
        : configs.find(item => item.id === this.selectChannel.id) || defaultChannel

      // 备用支付渠道列表
      const fallbackChannels = [
        'WAVE_CI', 'OM_CI', 'MTN_CI', 'MOOV_CI', 'vodacom', 'tigo', 
        'airtel', 'halotel', 'mtn-gh', 'vodafone-gh', 'tigo-gh', 'redirect'
      ]

      // 设置备用支付渠道
      if (!this.selectChannel) {
        for (const channel of fallbackChannels) {
          if (paymentMethodGroups[channel]?.length) {
            this.selectChannel = paymentMethodGroups[channel][0]
            break
          }
        }
      }

      // 构建支付方式列表
      const list = [this.telebirr[0], this.cbebirr[0], this.mpesa[0]]
        .concat(this.other)
        .concat(fallbackChannels.flatMap(channel => paymentMethodGroups[channel] || []))
        .filter(Boolean)

      this.methodConfig = chunkArray(list, 3, true)
      this.$emit('select', {
        channel: this.selectChannel,
        telebirr: this.telebirr,
        cbebirr: this.cbebirr,
        mpesa: this.mpesa,
        other: this.other
      })

      this.onSelectBankCode(0)
      setTimeout(() => closeToast(), 500)
    },
    onSelectBankCode(index) {
      this.seleceBankCode = index
      this.onUpdatePayMethod(
        this.methodConfig[Math.floor(this.seleceBankCode / 3)][this.seleceBankCode % 3]
      )
    },
    onUpdatePayMethod(payMethods) {
      // this.payMethods = payMethods;
      // this.selectedPayMethods = this.payMethods.filter(item => item.checked);
      console.log('selectedPayMethods', payMethods)
      this.selectChannel = payMethods
      this.$emit('select', {
        channel: payMethods,
        telebirr: this.telebirr,
        cbebirr: this.cbebirr,
        mpesa: this.mpesa,
        other: this.other
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dw_con_et {
  width: 94.5%;
  height: auto;
  padding: 3% 3% 3% 0;
  margin-bottom: -3%;
  border-radius: 0 0 0.16rem 0.16rem;
  margin-top: -2%;

  .om_inputbox {
    line-height: 0.7rem;
    background-color: #fff;
    background-image: linear-gradient(#eeeeee, #fff 15%);
    display: inline-block;
    height: 0.7rem;
    width: 100%;
    border-radius: 0.1rem;
    font-size: 0.24rem;
    // margin: 0.1rem 0 0 0;
    // padding: 0 5% 0 5%;
    margin-bottom: 0.2rem;
    border: 1px solid #bec3c7;

    input {
      outline-style: none;
      outline-width: 0;
      border: none;
      border-style: none;
      text-shadow: none;
      -webkit-appearance: none;
      -webkit-user-select: text;
      outline-color: transparent;
      background-color: transparent;
      box-shadow: none;
      font-size: 0.24rem;
      line-height: 0.7rem;
      padding-left: 5%;
      width: 100%;
      color: #000;
    }

    input::placeholder {
      color: #95a5a5;
    }
  }
}

.dw_con_et ul {
  width: 100%;
  height: auto;
  // padding: 0.3rem 0 0 0;
  margin: 0;
  // border-top-width: 1px;
  // border-bottom-width: 1px;
  // border-left-width: 1px;
  // border-top-style: solid;
  // border-bottom-style: solid;
  // border-top-color: #d9dee0;
  // border-bottom-color: #d9dee0;
}

.dw_title {
  height: auto;
  width: 100%;

  font-size: 0.24rem !important;
  color: #000;
  font-weight: normal;
  margin: 0;
}

.dw_Pay {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  margin-top: 0.2rem;

  .dw_row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 103%;

    .active_bankCode {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      // float: left;
      padding: 0.05rem 0.05rem;
      width: 100%;
      height: 0.8rem;
      margin: 0.05rem 0.01rem;
      border-radius: 0.16rem;
      // display: inline-block;
      font-size: 0.24rem;
      color: #fff !important;
      background-color: #ceb45f;
      border: 0.02rem solid #ceb45f !important;

      img {
        width: 100%;
        height: 100%;
        border-radius: 0.16rem;
      }
    }

    .un_active_bankCode {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #778989;
      text-align: center;
      width: 100%;
      height: 0.8rem;
      padding: 0.05rem 0.05rem;
      margin: 0.05rem 0.01rem;
      border-radius: 0.16rem;
      border: 0.02rem solid rgba($color: #000000, $alpha: 0);
      font-size: 0.24rem;

      img {
        width: 100%;
        height: 100%;
        border-radius: 0.16rem;
      }
    }
  }

  .active {
    text-align: center;
    float: left;
    padding: 0.2rem;
    margin: 0 0.1rem;
    border-radius: 0.35rem;
    display: inline-block;
    font-size: 0.24rem;
    color: #fff !important;
    background-color: #ceb45f;
    border: 0.02rem solid #ceb45f !important;
  }

  .un_active {
    color: #778989;
    text-align: center;
    float: left;
    padding: 0.2rem;
    margin: 0 0.1rem;
    border: 0.02rem solid #778989;
    border-radius: 0.35rem;
    display: inline-block;
    font-size: 0.24rem;
  }
}
</style>
